module.exports = __webpack_public_path__ + "img/ipay-2.d6fb46f8.svg";